import { useEffect, useState } from "react";

export const useIsLargeScreen = () => {
  const [isLargeScreen, setIsLargeScreen] = useState(() => {
    if (typeof window !== "undefined") {
      return window.innerWidth >= 1024;
    }
    return false;
  });

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth >= 1024); // Tailwind lg = 1024px
    };

    window.addEventListener("resize", handleResize);

    // Initial check (sometimes needed in case resize didn't fire yet)
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isLargeScreen;
};
